import { useSelector } from 'react-redux';
import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';

import {
  ORDER_TYPE_MODAL_KEY,
  getSessionStorageItem,
  setSessionStorageItem,
} from 'shared/app/utils/session-storage';

import {
  OrderTypeModal,
  ORDER_TYPE_MODAL_ID,
} from '../shared/order-type-modal';

import { showInAppModalSelector } from '../../state/selectors';

const useInAppOrderTypeModal = () => {
  const { openModal } = useModalContext();
  const modalShouldBeShown = useSelector(showInAppModalSelector);

  const openOrderTypeModal = () => {
    openModal({
      component: OrderTypeModal,
      ariaLabelledBy: ORDER_TYPE_MODAL_ID,
    });
    setSessionStorageItem(ORDER_TYPE_MODAL_KEY, true);
  };

  const modalSeen = getSessionStorageItem(ORDER_TYPE_MODAL_KEY);
  const showOrderTypeModal = () => {
    modalShouldBeShown && modalSeen !== true ? openOrderTypeModal() : null;
  };

  return { showOrderTypeModal };
};

export default useInAppOrderTypeModal;
